module.exports = __webpack_public_path__ + "media/application/images/svgs/public_square/chevron_featured-62454eb222d4cb964256a5736bf57f82.svg";